module.exports = __webpack_public_path__ + "static/media/04_Street_BG.2037d2a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/street/04_Street_BG.png
// module id = 423
// module chunks = 0